import { P2GAlert } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GDivider } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';
import { Consts, EditEventType } from '../../../../lib/em/EmitTypes';
import { useEventEmitter } from '../../../../lib/em/Hooks';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { EditType } from '../../item/EditType';
import { onlyUnique, onlyUniqueNonBlank } from '../../../../lib/helpers/ArrayHelper';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  group: ProviderGroup;
  removeItems: (ids: string[]) => void;
}

const ProviderGroupSummaryError: React.FC<props> = (props) => {
  const [idsInError, setIdsInError] = useState<string[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const { emit } = useEventEmitter<EditEventType>();

  const setEdit = (id: string) => {
    emit(Consts.Edit, { Id: id, Action: 'ADDRESS' as EditType });
  };

  useEffect(() => {
    setIdsInError((props.group.ShipResponse?.Errors.map((e) => e.ItemId) || []).filter(onlyUnique));
  }, [props.group.ShipResponse]);

  const removeItems = () => {
    props.removeItems(idsInError);
  };

  const hasIds = props.group.ShipResponse?.Errors?.map((e) => e.ItemId).filter(onlyUniqueNonBlank).length > 0;

  return (
    <P2GBox>
      <P2GText component="p" colour="primary">
        <Trans i18nKey="PROVIDER_GROUP_SUMMARY_ERROR" t={t} defaults="<strong>There was an Issue Booking...</strong>" />
      </P2GText>
      <P2GAlert color="error">
        <P2GGrid container direction="column" spacing={2}>
          {props.group.ShipResponse?.Errors.map((e) => (
            <P2GGrid item key={`${e.Error}_${e.ItemId}`}>
              {e.ItemId ? (
                <P2GCheckBoxLegacy
                  onChange={() =>
                    idsInError.includes(e.ItemId)
                      ? setIdsInError(idsInError.filter((x) => x != e.ItemId))
                      : setIdsInError([...idsInError, e.ItemId])
                  }
                  id={`${e.Error}_${e.ItemId}`}
                  checked={idsInError.includes(e.ItemId)}
                  label={
                    <>
                      <P2GText variant="body2">
                        {e.Error} ({e.ItemId})
                      </P2GText>
                      <div onClick={(e) => e.preventDefault()}>
                        <P2GLink onClick={() => setEdit(e.ItemId)}>
                          {t('PROVIDER_GROUP_SUMMARY_VIEW_ITEM_BUTTON', { defaultValue: 'View Item' })}
                        </P2GLink>
                      </div>
                    </>
                  }
                  labelPlacement="end"
                  variant="primary"
                  error={false}
                />
              ) : (
                <P2GText variant="body2">{e.Error}</P2GText>
              )}
            </P2GGrid>
          ))}
          {hasIds && (
            <>
              <P2GGrid item>
                <P2GDivider />
              </P2GGrid>
              <P2GGrid item>
                <P2GButton variant="primary" disabled={idsInError?.length === 0} onClick={removeItems}>
                  {t('PROVIDER_GROUP_SUMMARY_REMOVE_BUTTON', { defaultValue: 'Remove and Book Later' })}
                </P2GButton>
              </P2GGrid>
            </>
          )}
        </P2GGrid>
      </P2GAlert>
    </P2GBox>
  );
};

export default ProviderGroupSummaryError;
